/**
 * Known bad labels from BigQuery (measure / use_case tables).
 * Apply at API normalize boundaries so UI stays correct even before DB migration runs.
 *
 * Source ticket: spelling, trailing space, and "AShared" concatenation errors.
 */

const EXACT_LABEL_FIXES: Record<string, string> = {
  // use_case_id 1680
  'AShared IT Infrastructure and Cloud Services': 'Shared IT Infrastructure and Cloud Services',
  'AShared IT Infrastructure and Cloud Services (': 'Shared IT Infrastructure and Cloud Services',
  // measure_id 46 variants
  'Resource Avaliablity & Allocation': 'Resource Availability & Allocation',
  'Resource Avaliablity and Allocation': 'Resource Availability & Allocation',
  // measure_id 56 — trailing space variants handled via trim + exact map
  'Ease of Regulatory and Compliance Approval ': 'Ease of Regulatory and Compliance Approval',
};

const SUBSTRING_FIXES: Array<[RegExp, string]> = [
  [/Avaliablity/gi, 'Availability'],
  [/^AShared\b/g, 'Shared'],
];

/**
 * Clean a measure_name, description, or use-case title for display.
 */
export function sanitizeDisplayLabel(value: string | null | undefined): string {
  if (value == null) return '';
  let next = String(value).trim();
  if (!next) return '';

  const exact = EXACT_LABEL_FIXES[next] ?? EXACT_LABEL_FIXES[String(value)];
  if (exact) return exact;

  for (const [pattern, replacement] of SUBSTRING_FIXES) {
    next = next.replace(pattern, replacement);
  }

  return next.trim();
}

export default sanitizeDisplayLabel;
